import { SESSION_AUTH_ERROR_KEY } from 'src/config';

export interface AuthError {
  error: string;
  description: string | null;
}

// Auth0 sends failures back to redirect_uri as `?error=…&error_description=…`.
// Read-only: nothing here talks to Auth0.
export const readAuthErrorFromSearch = (search: string): AuthError | null => {
  const params = new URLSearchParams(search);
  const error = params.get('error');
  if (!error) return null;
  return { error, description: params.get('error_description') };
};

export const storeAuthError = (authError: AuthError | null): void => {
  if (!authError) return;
  try {
    sessionStorage.setItem(SESSION_AUTH_ERROR_KEY, JSON.stringify(authError));
  } catch (err) {
    // Storage disabled: the error is lost, same as before this existed.
  }
};

// Reads and clears, so a refresh doesn't show a stale error.
export const takeAuthError = (): AuthError | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_AUTH_ERROR_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(SESSION_AUTH_ERROR_KEY);
    const parsed = JSON.parse(raw);
    return typeof parsed?.error === 'string'
      ? { error: parsed.error, description: parsed.description ?? null }
      : null;
  } catch (err) {
    return null;
  }
};
